import React, { useState } from 'react';
import { MapPin, Check, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '@/components/ui/command';

/** Multi-city filter. Values are canonical keys, so one pick covers every spelling. */
export const CityMultiFilter = ({ cities = [], selected = [], onChange }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const toggle = (key) => {
    setQuery('');  // so the next city is reachable without clearing the box
    onChange(selected.includes(key) ? selected.filter((k) => k !== key) : [...selected, key]);
  };
  const label = selected.length === 0
    ? 'All cities'
    : selected.length === 1
      ? (cities.find((c) => c.key === selected[0])?.name || '1 city')
      : `${selected.length} cities`;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="city-filter-trigger"
          className="flex h-10 w-[190px] items-center justify-between rounded-md border border-slate-300 bg-white px-3 text-sm hover:bg-slate-50 transition-colors"
        >
          <span className="flex items-center gap-2 truncate">
            <MapPin className="h-4 w-4 text-slate-400 shrink-0" />
            <span className={selected.length ? 'text-slate-900' : 'text-slate-500'}>{label}</span>
          </span>
          <ChevronDown className="h-4 w-4 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[260px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search city…" value={query} onValueChange={setQuery} data-testid="city-filter-search" />
          <CommandList>
            <CommandEmpty>No city found.</CommandEmpty>
            <CommandGroup>
              {cities.map((c) => (
                <CommandItem key={c.key} value={c.name} onSelect={() => toggle(c.key)} data-testid={`city-option-${c.key}`}>
                  <Check className={`mr-2 h-4 w-4 ${selected.includes(c.key) ? 'opacity-100 text-blue-600' : 'opacity-0'}`} />
                  <span className="flex-1 truncate">{c.name}</span>
                  <span className="text-xs text-slate-400 ml-2">{c.count}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default CityMultiFilter;
